{
  /**
   * This is a tiny tiny alternative to jQuery to make work with elements easier
   * @param (string) selector | standard JS string selector
   * @param (node) context | default "document"
   *
   * Example usage:
   * ioQ(".menu-item a").style.backgroundColor = "pink"
   * ioQ(".menu-item a").map(el => el.href = "https://google.com")
   * ioQ(".menu-item a").addEventListener("click", e => { e.preventDefault(); console.log("clicked") })
   * ioQ(".menu-item a").remove()   
   * ioQ(".some-section").forEach(section => {
   *   ioQ(".sub-item", section).forEach(subItem => {
   *     // do something with `subItem` and/or `section`
   *   })
   * })
   */
  window.ioQ = (selector, context = document) => {
    const elements = Array.from(context.querySelectorAll(selector));

    // If no elements are found, return a no-op Proxy that ignores everything
    if (elements.length === 0) {
      return new Proxy({}, {
        get() {
          return () => {}; // Return an empty function, no operations are done
        },
        set() {
          return true; // Ignore any set attempts
        }
      });
    }

    return new Proxy(elements, {
      get(target, prop) {
        // If it's an array method, apply it to all
        if (prop in Array.prototype) {
          return (...args) => Array.prototype[prop].apply(target, args);
        }

        const firstEl = target[0];

        // If the property is a function, apply it to all elements
        if (typeof firstEl?.[prop] === 'function') {
          return (...args) => target.forEach(el => el[prop](...args));
        }

        // If the property is an object (like style), apply it to all elements
        if (typeof firstEl?.[prop] === 'object' && firstEl[prop] !== null) {
          return new Proxy(firstEl[prop], {
            get(_, key) {
              return firstEl[prop][key];
            },
            set(_, key, value) {
              target.forEach(el => (el[prop][key] = value));
              return true;
            }
          });
        }

        // Return the property of the first element
        return firstEl?.[prop];
      }
    });
  };
}